import { awaitSurfaceIdle } from '../../core/surface/surface.busy';
import type { AskBusyLeave } from '../../core/surface/surface.busy';

export interface DetailPatchSurface {
  readonly $readonly: () => boolean;
  readonly $saving: () => boolean;
  readonly $dirty: () => boolean;
  readonly $busy: () => boolean;
  readonly flushPatch: () => Promise<void>;
}

/** An upload outlives readonly and clean checks: it commits into the record only once it settles. */
export async function canDeactivateDetailSurface(surface: DetailPatchSurface | null | undefined, askBusyLeave: AskBusyLeave, timeoutMs = 30000): Promise<boolean> {

  if (!surface) return true;
  await awaitSurfaceIdle(surface, askBusyLeave);
  if (surface.$readonly()) return true;
  if (surface.$saving() && !await awaitNotSaving(surface, timeoutMs)) return false;
  if (!surface.$dirty()) return true;

  await surface.flushPatch();
  if (surface.$saving() && !await awaitNotSaving(surface, timeoutMs)) return false;
  return !surface.$dirty();
}

async function awaitNotSaving(surface: Pick<DetailPatchSurface, '$saving'>, timeoutMs: number): Promise<boolean> {

  const deadline = Date.now() + timeoutMs;
  while (surface.$saving() && Date.now() < deadline) await new Promise(resolve => setTimeout(resolve, 16));
  return !surface.$saving();
}
